<template>
	<div class="backend-manage layout-row">
		<left-nav></left-nav>
		<router-view class="routerView"></router-view>
	</div>
</template>

<script>
import LeftNav from "@/components/backendManage/BackendLeftNav";

export default {
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() { },
	mounted() { },
	components: {
		LeftNav
	}
};
</script>

<style lang="scss" scoped>
.backend-manage {
	min-width: 1000px;
	padding: 10px 10px 50px 10px;
}

.routerView {
	width: calc(100vw - 190px);
}
</style>